module.exports = __webpack_public_path__ + "img/s7.5d431f30.png";